import React from "react";
import cssExports from "theme/styles/main.module.scss";

/**
 * The report itself. The service renders the markdown to HTML and escapes raw HTML and
 * dangerous-scheme (javascript:/vbscript:/data:/file:) links before sending, which is what makes
 * `dangerouslySetInnerHTML` acceptable here — the same trade the customer-facing
 * `monthlyReportView` already makes. Never point this at anything but that server-rendered field.
 */
const MonthlyReportBody: React.FC<{ html?: string }> = ({ html }) => (
  <div className={cssExports.advisorMonthlyReportBody} dangerouslySetInnerHTML={{ __html: html ?? "" }} />
);

export default MonthlyReportBody;
